let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("dIUs7")).then(() => parcelRequire('cLFIZ'));